import { render, staticRenderFns } from "./Page-Map-Nomads.vue?vue&type=template&id=1841d99f&"
import script from "./Page-Map-Nomads.vue?vue&type=script&lang=js&"
export * from "./Page-Map-Nomads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports